module.exports = __webpack_public_path__ + "static/media/homecleaning.ce72e9d8.png";